/*
  One motion grammar for the whole sheet: paper has mass. A strip springs to
  where it is going, overshoots a little and settles, and strips leave one after
  another (STAGGER_MS apart), the way the shards of species-in-pieces do.
  Nothing snaps and nothing eases linearly.
*/

export interface Spring {
  x: number;
  v: number;
}

/** Stiffness and damping: damping ratio ~0.7, so about a 5% overshoot. */
export const STIFFNESS = 90;
export const DAMPING = 13;
export const STAGGER_MS = 45;

/** Advance a unit-mass spring toward `target` by `dt` seconds (semi-implicit Euler). */
export function step(s: Spring, target: number, dt: number, stiffness = STIFFNESS, damping = DAMPING): Spring {
  const a = -stiffness * (s.x - target) - damping * s.v;
  const v = s.v + a * dt;
  return { x: s.x + v * dt, v };
}

export const settled = (s: Spring, target: number) => Math.abs(s.x - target) < 0.0015 && Math.abs(s.v) < 0.0015;

/** Frame time, capped so a backgrounded tab does not fling the paper on its return. */
export const frameDt = (now: number, last: number) => Math.min(0.034, Math.max(0, (now - last) / 1000));
